import { useCallback, useState, type ReactNode } from "react";

import { RegistrationSwitchProfileContext } from "@repo/tests-web";

import { SwitchProfileModal } from "../header/SwitchProfileModal";

type TestsSwitchProfileHostProps = {
  children: ReactNode;
};

export function TestsSwitchProfileHost({
  children,
}: TestsSwitchProfileHostProps) {
  const [switchProfileOpen, setSwitchProfileOpen] = useState(false);

  const openSwitchProfile = useCallback(() => {
    setSwitchProfileOpen(true);
  }, []);

  const closeSwitchProfile = useCallback(() => {
    setSwitchProfileOpen(false);
  }, []);

  return (
    <RegistrationSwitchProfileContext.Provider value={{ openSwitchProfile }}>
      {children}
      <SwitchProfileModal
        isOpen={switchProfileOpen}
        onClose={closeSwitchProfile}
      />
    </RegistrationSwitchProfileContext.Provider>
  );
}
